export const imports = {
  'src/docs/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-index" */ 'src/docs/index.mdx'
    ),
  'src/docs/base/base.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-base-base" */ 'src/docs/base/base.mdx'
    ),
  'src/docs/common/commonTypes.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-common-common-types" */ 'src/docs/common/commonTypes.mdx'
    ),
  'src/docs/common/defaults.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-common-defaults" */ 'src/docs/common/defaults.mdx'
    ),
  'src/docs/components/component.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-components-component" */ 'src/docs/components/component.mdx'
    ),
  'src/docs/components/containers.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-components-containers" */ 'src/docs/components/containers.mdx'
    ),
  'src/docs/components/grid.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-components-grid" */ 'src/docs/components/grid.mdx'
    ),
  'src/docs/components/horizontal.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-components-horizontal" */ 'src/docs/components/horizontal.mdx'
    ),
  'src/docs/components/responsive.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-components-responsive" */ 'src/docs/components/responsive.mdx'
    ),
  'src/docs/components/spacers.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-components-spacers" */ 'src/docs/components/spacers.mdx'
    ),
  'src/docs/components/vertical.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-components-vertical" */ 'src/docs/components/vertical.mdx'
    ),
  'src/docs/guidance/components.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-guidance-components" */ 'src/docs/guidance/components.mdx'
    ),
  'src/docs/guidance/guidance.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-guidance-guidance" */ 'src/docs/guidance/guidance.mdx'
    ),
  'src/docs/guidance/layouts.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-guidance-layouts" */ 'src/docs/guidance/layouts.mdx'
    ),
  'src/docs/principles/scrolling.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-principles-scrolling" */ 'src/docs/principles/scrolling.mdx'
    ),
  'src/docs/principles/sizing.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-principles-sizing" */ 'src/docs/principles/sizing.mdx'
    ),
  'src/docs/principles/spacing.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-principles-spacing" */ 'src/docs/principles/spacing.mdx'
    ),
}
